const DEFAULT_PRODUCTION_JOBS_API_URL =
  'https://us-central1-jobsprojectv1.cloudfunctions.net/GetJobs24HoursV1';

const LOCAL_API_PATTERN = /(localhost|127\.0\.0\.1|0\.0\.0\.0)/i;

const normalizeQueryString = (params) => {
  if (!params) return '';
  if (typeof params === 'string') return params.replace(/^\?/, '').trim();
  if (params instanceof URLSearchParams) return params.toString();
  return new URLSearchParams(params).toString();
};

export const resolveJobsApiCandidates = (
  configuredUrl = process.env.REACT_APP_JOBS_API_URL || DEFAULT_PRODUCTION_JOBS_API_URL
) => {
  const normalizedConfigured =
    String(configuredUrl || '').trim() || DEFAULT_PRODUCTION_JOBS_API_URL;
  const candidates = [normalizedConfigured];

  if (
    LOCAL_API_PATTERN.test(normalizedConfigured) &&
    normalizedConfigured !== DEFAULT_PRODUCTION_JOBS_API_URL
  ) {
    candidates.push(DEFAULT_PRODUCTION_JOBS_API_URL);
  }

  return Array.from(new Set(candidates));
};

export const buildJobsApiEndpoint = (baseUrl, params) => {
  const normalizedBase = String(baseUrl || '').trim();
  const query = normalizeQueryString(params);
  if (!query) return normalizedBase;
  return `${normalizedBase}${normalizedBase.includes('?') ? '&' : '?'}${query}`;
};

export const fetchJobsApiPayload = async (params, options = {}) => {
  const fetchImpl = options.fetchImpl || fetch;
  const apiCandidates =
    Array.isArray(options.apiCandidates) && options.apiCandidates.length
      ? Array.from(
          new Set(options.apiCandidates.map((url) => String(url || '').trim()).filter(Boolean))
        )
      : resolveJobsApiCandidates();

  let lastError = null;

  for (const baseUrl of apiCandidates) {
    try {
      const apiResult = await fetchImpl(buildJobsApiEndpoint(baseUrl, params), { method: 'GET' });
      if (!apiResult.ok) {
        throw new Error(`HTTP ${apiResult.status}`);
      }
      return await apiResult.json();
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error('Jobs API request failed');
};

export { DEFAULT_PRODUCTION_JOBS_API_URL };
